import { lazy } from 'react';
import { SETTINGS_PERMISSIONS } from './constants';

const SettingsPage = lazy(() => import('./pages/SettingsPage'));
const FeatureFlagsPage = lazy(() => import('./pages/FeatureFlagsPage'));

export const settingsRoutes = [
  {
    path: '/settings',
    element: SettingsPage,
    permission: SETTINGS_PERMISSIONS.WRITE,
    nav: { labelKey: 'nav.settings', icon: 'SettingOutlined', group: 'system' },
  },
  {
    path: '/settings/feature-flags',
    element: FeatureFlagsPage,
    permission: SETTINGS_PERMISSIONS.WRITE,
    nav: { labelKey: 'nav.featureFlags', icon: 'FlagOutlined', group: 'system' },
  },
];
